import classNames from 'classnames';
import React, { useCallback } from 'react';
import { pages } from '../pageNumberForm';

import { ReactComponent as BackArrow } from './backArrow.svg';
import { ReactComponent as NextArrow } from './nextArrow.svg';
import { ReactComponent as Loader } from './../../projectPost/PublishedProposals/loader.svg';
import PropTypes from 'prop-types';

const Buttons = ({ page, setPage, isSubmitting }) => {
    const handleChangePage = useCallback(() => setPage(pages.firstPage), [setPage]);

    const submitButtonClass = classNames({
        next: page === pages.firstPage,
        publish: page === pages.secondPage,
    });

    return (
        <div className="buttons">
            {page === pages.secondPage && (
                <button type="button" className="back" onClick={handleChangePage}>
                    <BackArrow />
                    <span className="buttonText">Back</span>
                </button>
            )}
            <button type="submit" className={submitButtonClass} disabled={isSubmitting}>
                <span className="buttonText">{page === pages.firstPage ? 'Next' : 'Publish'}</span>
                {page === pages.firstPage && <NextArrow />}
                {page === pages.secondPage && isSubmitting && <Loader />}
            </button>
        </div>
    );
};

Buttons.propTypes = {
    page: PropTypes.number.isRequired,
    setPage: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
};

export default Buttons;
